import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle, CalendarClock } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;
const WD = ["Domingo", "Segunda", "Terça", "Quarta", "Quinta", "Sexta", "Sábado"];
const fmtDay = (iso) => { const d = new Date(iso + "T00:00:00"); return `${WD[d.getDay()]} · ${String(d.getDate()).padStart(2, "0")}/${String(d.getMonth() + 1).padStart(2, "0")}`; };

export default function ConsultaSucesso() {
  const [sp] = useSearchParams();
  const bookingId = sp.get("booking");
  const [data, setData] = useState(null);
  const [tries, setTries] = useState(0);

  useEffect(() => {
    if (!bookingId) return;
    let stop = false;
    const poll = async () => {
      try {
        const r = await fetch(`${API}/api/public/booking/${bookingId}/status`);
        const j = await r.json();
        if (stop) return;
        setData(j);
        if (j.status !== "paid" && j.status !== "expired" && tries < 20) {
          setTimeout(() => setTries((t) => t + 1), 3000);
        }
      } catch { /* retry via tries */ }
    };
    poll();
    return () => { stop = true; };
  }, [bookingId, tries]);

  const status = data?.status;
  const paid = status === "paid";
  const expired = status === "expired";
  const pending = !status || status === "held";

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 px-5" data-testid="consulta-sucesso">
      <div className="w-full max-w-md rounded-3xl border border-slate-200 bg-white p-8 text-center shadow-xl">
        {pending && <><Loader2 className="mx-auto h-12 w-12 animate-spin text-blue-600" /><h1 className="mt-4 font-heading text-xl font-extrabold text-slate-900">Confirmando pagamento…</h1><p className="mt-1 text-sm text-slate-500">Aguarde, estamos verificando sua reserva.</p></>}
        {paid && <>
          <CheckCircle2 className="mx-auto h-12 w-12 text-emerald-600" data-testid="status-paid" />
          <h1 className="mt-4 font-heading text-xl font-extrabold text-slate-900">Consulta agendada! 🎉</h1>
          <p className="mt-2 text-sm text-slate-600">Sua consulta <b>{data.modality}</b>{data.doctor_name ? <> com <b>{data.doctor_name}</b></> : null} está confirmada para:</p>
          <p className="mt-2 flex items-center justify-center gap-2 rounded-xl border border-emerald-200 bg-emerald-50 py-3 font-semibold text-emerald-700"><CalendarClock className="h-4 w-4" /> {fmtDay(data.date)} às {data.time}</p>
          <p className="mt-3 text-xs text-slate-400">Você receberá os detalhes por e-mail.</p>
        </>}
        {expired && <>
          <XCircle className="mx-auto h-12 w-12 text-rose-500" data-testid="status-expired" />
          <h1 className="mt-4 font-heading text-xl font-extrabold text-slate-900">Reserva expirada</h1>
          <p className="mt-2 text-sm text-slate-500">O prazo de 30 minutos para pagamento terminou e o horário foi liberado. Escolha um novo horário.</p>
        </>}
        {data?.slug && <Link to={`/${data.slug}`} data-testid="back-to-doctor" className="mt-6 inline-block rounded-xl bg-slate-900 px-5 py-2.5 text-sm font-bold text-white hover:bg-slate-800">Voltar à página do profissional</Link>}
      </div>
    </div>
  );
}
